function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Social Twitter Icon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "SOCIAL-ICONS",
  transform: "translate(0.000000, -4.000000)",
  fill: "currentcolor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.4479174,4.29502151 C18.6556156,4.75862675 17.7762169,5.09438932 16.8420313,5.27561682 C16.0946829,4.49170252 15.0270422,4 13.8470183,4 C11.5810915,4 9.74362576,5.80806041 9.74362576,8.03898499 C9.74362576,8.35648433 9.78015031,8.66414962 9.84898504,8.95917113 C6.4395589,8.79199227 3.41645009,7.1834226 1.39214722,4.74036351 C1.03954485,5.33602599 0.83725504,6.03002898 0.83725504,6.77039248 C0.83725504,8.17104223 1.56212685,9.40732286 2.66348248,10.1322329 C1.9905879,10.1111599 1.35702746,9.92993239 0.803540072,9.62648169 L0.803540072,9.67705681 C0.803540072,11.6340328 2.21816394,13.2664852 4.09636862,13.6387743 C3.75079019,13.7314953 3.38975908,13.7806656 3.01468006,13.7806656 C2.75057948,13.7806656 2.49350284,13.7539731 2.24204537,13.7076126 C2.76603217,15.3119677 4.28039615,16.4808148 6.0757182,16.5131267 C4.67092786,17.5962771 2.90229683,18.2425147 0.979138864,18.2425147 C0.646203554,18.2425147 0.321696987,18.2228466 0,18.1863201 C1.8163939,19.3312846 3.97415186,20 6.29065112,20 C13.8371848,20 17.963054,13.8452893 17.963054,8.50820968 C17.963054,8.33260163 17.9616492,8.15839845 17.9532205,7.98560014 C18.753951,7.41663008 19.450727,6.70436386 20,5.89375713 C19.2638899,6.21547107 18.4743977,6.43182018 17.6427618,6.53016068 C18.4912552,6.03002898 19.1402683,5.23909035 19.4479174,4.29502151",
  id: "Fill-20"
})));

var SvgSocialTwitter = function SvgSocialTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSocialTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/social-twitter.148e097c.svg";
export { ForwardRef as ReactComponent };